import { render, staticRenderFns } from "./menuBotoes.vue?vue&type=template&id=f222ab30&"
import script from "./menuBotoes.vue?vue&type=script&lang=js&"
export * from "./menuBotoes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports